import { useEffect, useState } from 'react';
import {
  UserDTO,
  UserClient,
  SearchRequestDTO_userSearchRequestDTO,
} from '../services/apiClient';
import axiosInstance from '../services/axiosInstance';
import { API_BASE_URL } from '../config/config';

export const getUsers = () => {
  const [users, setUsers] = useState<UserDTO[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const userClient = new UserClient(API_BASE_URL, axiosInstance);

  useEffect(() => {
    const fetchUsers = async () => {
      setIsLoading(true);
      const searchRequest: SearchRequestDTO_userSearchRequestDTO = {
        filters: {},
        sortBy: 'FirstName',
        sortDescending: false,
      };
      try {
        const result = await userClient.searchUsers(searchRequest);
        if (result && result.success && result.data) {
          setUsers(result.data.results as UserDTO[] || []);
        } else {
          setError('Failed to fetch users');
        }
      } catch (err) {
        setError('Error fetching users');
        console.error('Error fetching users:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUsers();
  }, []);

  return { users, isLoading, error };
};
